<hs-lazy-load-panel [content]="lazyLoadPanelContent" [panelKey]="panelKey">
</hs-lazy-load-panel>

<ng-template #lazyLoadPanelContent>
  <hs-no-loaded-account [content]="securitiesSelected"> </hs-no-loaded-account>
</ng-template>

<ng-template #securitiesSelected>
  <hs-securities-selected
    #securitiesSelectedComponent
    [content]="securityDetails"
    (securitySelectionChange)="onSecuritySelectionChanged($event)"
  >
  </hs-securities-selected>
</ng-template>

<ng-template #securityDetails>
  <security-details-panel-web
    [securityId]="securityId"
    [accountId]="accountId"
  ></security-details-panel-web>
</ng-template>
